<template>
	<div class="pageArea">
		<Head2></Head2>
		<div class="mainAea">
			<div class="tabs">
				<div class="tab active">
					<div class="tabInner">
						<div class="tabNum">1</div>
						<div class="line"></div>
					</div>
					<div>{{$t('pages.pay.tab_online')}}</div>
				</div>
				<div class="tab">
					<div class="tabInner">
						<div class="line"></div>
						<div class="tabNum">2</div>
					</div>
					<div class="textRight">{{$t('pages.pay.tab_done')}}</div>
				</div>
			</div>

			<div class="payArea">
				<div class="infoArea">
					<div class="payInfo">
						<img src="../assets/images/ok2.png" />
						<div>{{$t('pages.pay.order_submitted_msg')}}</div>
					</div>
					<div class="orderInfo">
						<div class="orderFlex">
							<div>{{$t('pages.pay.order_no')}}{{orderInfo.order_no}}</div>
							<div>{{$t('pages.pay.order_amount')}}<span>￥{{orderInfo.order_amount}}</span></div>
						</div>
						<div class="orderFlex" v-if="orderInfo.order_state==0">{{$t('pages.pay.countdown1')}}<span>{{$t('pages.pay.countdown2', {hours: hours})}}</span> <span>{{$t('pages.pay.countdown3', {minutes: minutes})}}</span>
							<span>{{$t('pages.pay.countdown4', {seconds: seconds})}}</span>{{$t('pages.pay.countdown5')}}</div>
						<div class="orderFlex">{{$t('pages.pay.paid_success')}}</div>
					</div>
				</div>

				<div v-if="orderInfo.order_state==0">
					<div class="payList">
						<div class="payLi">
							<input type="radio" class="radio-input" id="pay1" value="pay1" v-model="selected" />
							<img src="../assets/images/pay1.png" />
						</div>
						<div class="payLi">
							<input type="radio" class="radio-input" id="pay2" value="pay2" v-model="selected" />
							<img src="../assets/images/pay2.png" />
						</div>
						<div class="payLi">
							<input type="radio" class="radio-input" id="pay3" value="pay3" v-model="selected" />
							<img src="../assets/images/pay3.png" />
						</div>
					</div>

					<div class="payInner" v-if="selected === 'pay1'">
						<div class="payCell">
							<img :src="aliPayImage" />
							<div class="payBottom">
								<img src="../assets/images/sao.png" />
								<div>
									<p>{{$t('pages.pay.open_alipay')}}</p>
									<p>{{$t('pages.pay.scan_to_pay')}}</p>
								</div>
							</div>
						</div>
						<router-link  :to="{path:'/my',query:{type:'ORDER',state:0}}">
							<div class="payBtn payBtnbig">{{$t('pages.pay.ive_paid_view_order')}}</div>
						</router-link>

					</div>

					<div class="payInner" v-else-if="selected === 'pay2'">
						<div class="payCell">
							<img :src="wxPayImage">
							<div class="payBottom">
								<img src="../assets/images/sao.png" />
								<div>
									<p>{{$t('pages.pay.open_wechat')}}</p>
									<p>{{$t('pages.pay.scan_to_pay')}}</p>
								</div>
							</div>
						</div>
						<router-link  :to="{path:'/my',query:{type:'ORDER',state:0}}">
							<div class="payBtn payBtnbig">{{$t('pages.pay.ive_paid_view_order')}}</div>
						</router-link>
					</div>

					<div class="payInner" v-else-if="selected === 'pay3'">
						<div class="payBtn">{{$t('pages.pay.proceed_to_pay')}}</div>

					</div>

				</div>

			</div>
		</div>
		<Foot2></Foot2>
	</div>
</template>

<script>
	import Head2 from '../components/head2.vue';
	import Foot2 from '../components/foot2.vue';
	export default {
		components: {
			Head2,
			Foot2,
		},
		data() {
			return {
				selected: 'pay1',
				orderId: 0,
				orderInfo: {},
				aliPayImage: '',
				wxPayImage: '',
				// 设置倒计时结束的时间
				endTime: '',
				// 初始化倒计时时间
				days: 0,
				hours: 0,
				minutes: 0,
				seconds: 0,
			}
		},
		created() {
			this.orderId = this.$route.query.id;
			//console.log(this.orderId);
			this.getOrderInfo();
			//

		},
		methods: {
			getOrderInfo() {
				this.$scUtil.axiosPost(this, 'OrderApi/GetOrderInfo', {
					orderId: this.orderId,
					userName: localStorage.getItem('username'),
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.orderInfo = res.data[0];
						//console.log(JSON.stringify(this.orderInfo))
						this.getPayQRCode(this.orderInfo.alipayurl);
						this.getWxPayQRCode(this.orderInfo.wxpayurl);
						this.endTime = this.orderInfo.endtime;
						this.startCountdown();

					}
				});
			},
			getPayQRCode(url) {
				this.$scUtil.axiosPostImage(this, 'OrderApi/GenerateQRCode', url, res => {
					this.aliPayImage = res;
					//console.log(this.aliPayImage);
				});
			},
			getWxPayQRCode(url) {
				this.$scUtil.axiosPostImage(this, 'OrderApi/GenerateQRCode', url, res => {
					this.wxPayImage = res;
					//console.log(this.aliPayImage);
				});
			},
			startCountdown() {
				// 获取当前时间和结束时间
				const now = new Date();
				const end = new Date(this.endTime);

				// 计算时间差
				const diff = end - now;
				//console.log(diff);
				// 如果时间差小于0，则停止倒计时
				if (diff < 0) {
						this.stopCountdown();
					return;
				}

				// 更新倒计时时间
				this.days = Math.floor(diff / (1000 * 60 * 60 * 24));
				this.hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				this.minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
				this.seconds = Math.floor((diff % (1000 * 60)) / 1000);

				// 使用setTimeout递归调用，每秒更新一次
				setTimeout(this.startCountdown, 1000);
			},
			stopCountdown() {
				// 可以在这里添加倒计时结束后的逻辑
				console.log('倒计时结束');
				this.days = 0;
				this.hours=0;
				this.minutes=0;
				this.seconds=0;
			},
		}
	}
</script>

<style scoped>
	.pageArea {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.mainAea {
		width: 1200px;
		margin-top: 16px;
		margin-bottom: 17px;
		display: flex;
		flex-direction: column;
	}

	.tabs {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1200px;
	}

	.line {
		width: 196px;
		height: 3px;
		background: #d1d1d1;
	}

	.tabNum {
		font-size: 18px;
		font-weight: bolder;
		color: #d1d1d1;
		border: 3px solid #d1d1d1;
		width: 32px;
		height: 32px;
		text-align: center;
		border-radius: 50px;
		line-height: 32px;
	}

	.tabInner {
		display: flex;
		align-items: center;
		margin-bottom: 5px;
	}

	.tab.active .line {
		background: #0380fe;
	}

	.tab {
		font-size: 13px;
		color: #000;
	}

	.tab.active {
		color: #0380fe;
	}

	.tab.active .tabNum {
		background: #0380fe;
		border: 3px solid #0380fe;
		color: #fff;
	}

	.textRight {
		text-align: right;
	}

	.payArea {
		width: 1200px;
		border: 1px solid #d1d1d1;
		padding: 20px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.payInfo {
		display: flex;
		align-items: center;
		font-size: 18px;
		color: #63c42c;
		font-weight: bolder;
	}

	.infoArea {
		background: #faf4f4;
		width: 1109px;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 16px;
		box-sizing: border-box;
		line-height: 30px;
	}


	.orderInfo {
		font-size: 13px;
		color: #666;
	}

	.orderInfo span {
		color: #ff0000;
		font-size: 14px;
		font-weight: bolder;
		margin: 0 5px;
	}

	.orderFlex {
		display: flex;
		align-items: center;
	}

	.orderFlex div {
		margin-right: 15px;
	}


	.payList {
		display: flex;
		align-items: center;
		margin: 40px 0;
	}

	.payLi {
		display: flex;
		align-items: center;
		margin-right: 40px;
	}

	.payLi img {
		margin-left: 10px;
	}

	.payBtn {
		width: 180px;
		height: 48px;
		background: #0380fe;
		font-size: 14px;
		color: #fff;
		border-radius: 10px;
		text-align: center;
		line-height: 48px;
		margin-bottom: 10px;
	}

	.payBtnbig {
		width: 220px;
	}

	.payBottom {
		display: flex;
		align-items: center;
		margin-top: 10px;
		font-size: 12px;
		color: #999;
		margin-left: 15px;
	}

	.payBottom img {
		margin-right: 10px;
	}

	.payCell {
		width: 242px;
		height: 303px;
		border: 1px solid #d1d1d1;
		box-shadow: 0 0 10px -5px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-bottom: 50px;
	}

	.payInner {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>